import { ElementType } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  titleId?: string;
  titleAs?: ElementType;
  copy?: string;
  centered?: boolean;
  light?: boolean;
}

export function SectionHeading({ eyebrow, title, titleId, titleAs: TitleTag = "h2", copy, centered = false, light = false }: SectionHeadingProps) {
  return (
    <div className={`${centered ? "mx-auto text-center" : ""} max-w-3xl`}>
      {eyebrow && (
        <p className="mb-3 text-xs font-black uppercase tracking-[0.14em] text-[var(--accent)]">
          {eyebrow}
        </p>
      )}
      <TitleTag id={titleId} className={`font-serif text-3xl font-medium leading-tight sm:text-4xl lg:text-5xl ${light ? "text-[var(--text-inverse)]" : "text-[var(--text-strong)]"}`}>
        {title}
      </TitleTag>
      {copy && (
        <p className={`mt-4 text-base leading-7 ${light ? "text-white/75" : "text-[var(--text-muted)]"}`}>
          {copy}
        </p>
      )}
    </div>
  );
}
